
export class UserAuthenticationModel {
  id: string;
  userId: string;
}
